import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaCar, FaDollarSign, FaPhone, FaArrowRight } from 'react-icons/fa';
import { COMPANY_CONTACT, SERVICE_AREAS } from '../config/company';
import './Home.css';

const Home = () => {
  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: 'Prime Locations',
      description: 'Strategic billboard placements across Calhoun County for maximum visibility and impact.'
    },
    {
      icon: <FaCar />,
      title: 'High Traffic Areas',
      description: 'Locations with heavy daily traffic counts ensuring your message reaches thousands of potential customers.'
    },
    {
      icon: <FaDollarSign />,
      title: 'Affordable Rates',
      description: 'Competitive pricing that fits your budget while delivering exceptional advertising value.'
    }
  ];



  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Calhoun County's Most
              <span className="hero-highlight"> Affordable</span>
              <br />
              Billboard Company
            </h1>
            <p className="hero-subtitle">
              Premier outdoor advertising in {SERVICE_AREAS.join(', ')}. 
              Get your message seen by thousands of potential customers every day.
            </p>
            <div className="hero-actions">
              <Link to="/inventory" className="btn btn-primary">
                View Our Inventory
                <FaArrowRight />
              </Link>
              <a href={`tel:${COMPANY_CONTACT.phoneLink}`} className="btn btn-secondary">
                <FaPhone />
                Call Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section features-section">
        <div className="container">
          <h2 className="section-title">Why Choose Bama Billboards?</h2>
          <p className="section-subtitle">
            We provide the best outdoor advertising solutions in Calhoun County with superior customer service and competitive rates.
          </p>
          
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Areas Section */}
      <section className="section service-areas-section">
        <div className="container">
          <div className="service-areas-content">
            <div className="service-areas-text">
              <h2>Service Areas</h2>
              <p>
                We proudly serve the following cities in Calhoun County, Alabama, 
                providing comprehensive outdoor advertising solutions for local businesses.
              </p>
              <ul className="areas-list">
                {SERVICE_AREAS.map((area, index) => (
                  <li key={index}>{area}</li>
                ))}
              </ul>
              <Link to="/contact" className="btn btn-primary">
                Get Started Today
              </Link>
            </div>
            <div className="service-areas-visual">
              <div className="map-placeholder">
                <FaMapMarkerAlt />
                <p>Calhoun County, Alabama</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Get Your Message Out There?</h2>
            <p>
              Join hundreds of satisfied customers who trust Bama Billboards for their outdoor advertising needs. 
              Contact us today for a free consultation and competitive quote.
            </p>
            <div className="cta-actions">
                          <a href={`tel:${COMPANY_CONTACT.phoneLink}`} className="btn btn-primary">
              <FaPhone />
              Call {COMPANY_CONTACT.phone}
            </a>
              <Link to="/contact" className="btn btn-secondary">
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 